import React from 'react';
import { expertiseData } from '../data/mock';

const ExpertiseCloud = () => {
  const getTagSize = (size) => {
    switch(size) {
      case 'large': return 'tag-lg';
      case 'medium': return 'tag-md';
      default: return 'tag-sm';
    }
  };

  return (
    <section className="expertise-section">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Skills</span>
          <h2 className="heading-2">Areas of Expertise</h2>
        </div>
        
        <div className="expertise-cloud">
          {expertiseData.map((skill, index) => (
            <span 
              key={index} 
              className={`expertise-tag ${getTagSize(skill.size)}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {skill.name}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExpertiseCloud;
